import * as React from 'react';
import { ICase } from '../../../../share/types/case/case';
import { CircumstanceLayout } from '../layouts/Circumstances';

export interface ICircumstancesFormState {
  clicked: { [key: string]: boolean };
};

export interface ICircumstancesFormProps {
  caseInfo: ICase;
  setValue: (path: string, value: any) => void;
  form: (name: string, required: boolean) => void;
  submitted: boolean;
  disabled: boolean;
  isEditCase: boolean;
};

export class CircumstancesForm extends React.Component<ICircumstancesFormProps, ICircumstancesFormState> {
  constructor(props: ICircumstancesFormProps) {
    super(props);
    this.state = {
      clicked: {}
    }
  }


  public regionHandler(key: string) {
    const { caseInfo, disabled } = this.props
    return {
      name: key,
      required: key === "country",
      value: caseInfo[key],
      classes: this.getInputClasses(key),
      onChange: (value: any) => {
        this.setState({
          clicked: {
            ...this.state.clicked,
            [key]: true
          }
        })
        this.props.setValue(`caseInfo.${key}`, value)
      },
      disabled
    }
  }
  public render() {
    return <CircumstanceLayout that={this} />;
  }
  public checkError(name: string) {
    return this.props.caseInfo[name] === "" && (this.state.clicked[name] || this.props.submitted)
  }
  public getInputClasses(name: string) {
    return `form-control ${this.checkError(name) ? "is-invalid" : ""}`
  }
}

export default ICircumstancesFormProps;



// WEBPACK FOOTER //
// ./src/modules/Case/Add/components/CircumstancesForm.tsx